import { Component, EventEmitter, Output } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-workplans-popup-approval',
  imports: [TranslatePipe, RTLDivDirectiveDirective],
  templateUrl: './workplans-popup-approval.html',
  styleUrl: './workplans-popup-approval.scss',
})
export class WorkplansPopupApproval {
  @Output() approveCancelChangesEmitter = new EventEmitter<any>();
	currentLang;
  	translationsObj;
	translate;

	constructor(private translator: TranslatorService) {
		this.translate = this.translator;
		this.translator.currentLangEmitter$
		.subscribe(async value=>{						
		  this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
		  this.currentLang = value;	
		})
	 }

	ngOnInit() {
	}

	public approveCancelChanges = (approve: Boolean) => {
		this.approveCancelChangesEmitter.emit(approve);
	}
}
